/**
 * ViewGrid Skeleton Component
 *
 * Loading skeleton for the ViewGrid while data is being fetched.
 */

import React from "react";
import { Box, Skeleton } from "@mui/joy";

interface ViewGridSkeletonProps {
  rows?: number;
  columns?: number;
}

export default function ViewGridSkeleton({
  rows = 10,
  columns = 6,
}: ViewGridSkeletonProps) {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Toolbar skeleton */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 2 }}>
        <Skeleton variant="rectangular" width={120} height={36} />
        <Skeleton variant="rectangular" width={100} height={36} />
      </Box>

      {/* Row count skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={80} />
      </Box>

      {/* Header row skeleton */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          mb: 1,
          p: 1,
          bgcolor: "background.level1",
          borderRadius: 1,
        }}
      >
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton
            key={`header-${i}`}
            variant="rectangular"
            width={`${100 / columns}%`}
            height={32}
          />
        ))}
      </Box>

      {/* Data rows skeleton */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box
          key={`row-${rowIndex}`}
          sx={{
            display: "flex",
            gap: 1,
            mb: 0.5,
            p: 1,
          }}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton
              key={`cell-${rowIndex}-${colIndex}`}
              variant="rectangular"
              width={`${100 / columns}%`}
              height={28}
            />
          ))}
        </Box>
      ))}

      {/* Pagination skeleton */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
        <Skeleton variant="rectangular" width={100} height={32} />
        <Skeleton variant="rectangular" width={150} height={32} />
      </Box>
    </Box>
  );
}
